import React from 'react';
import Hero from '../components/home/Hero';
import TrustBadges from '../components/home/TrustBadges';
import PackagesPreview from '../components/home/PackagesPreview';
import MaintenanceSection from '../components/home/MaintenanceSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import FounderPreview from '../components/home/FounderPreview';
import ReviewsSection from '../components/home/ReviewsSection';
import CeramicHighlight from '../components/home/CeramicHighlight';
import BeforeAfter from '../components/home/BeforeAfter';
import SocialStrip from '../components/social/SocialStrip';
import AddOnsSection from '../components/home/AddOnsSection';
import QuoteSection from '../components/quote/QuoteSection';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';

export default function Home() {
  return (
    <div className="w-full">
      <Hero />
      <TrustBadges />
      <PackagesPreview />
      <MaintenanceSection />
      <WhyChooseUs />
      <FounderPreview />
      <ReviewsSection />
      <SocialStrip />
      <CeramicHighlight />
      <BeforeAfter />
      <AddOnsSection />
      <QuoteSection />
      <FAQSection />
      <CTASection />
    </div>
  );
}